import { AttendanceFilterOptionValue, FilterKey } from "@studyportals/search-filters";
import { FilterSelectionState } from "@/filters/selection/FilterSelectionState";
import { SortingState } from "@/sorting/SortingState";
import { SortingOptions } from "@/sorting/SortingOptions";
import { SeoHeadingHandler } from "../../SeoHeadingHandler";

export class Attendance extends SeoHeadingHandler {

	public async canHandle(sortState: SortingState, filterSelectionState: FilterSelectionState): Promise<boolean> {
		const metaRankingSortSelected = await this.sortingOptionSelected(SortingOptions.UNIVERSITY_META_RANKING, sortState);
		const attendanceSelected = await this.singleSelectionFor(FilterKey.DELIVERY_METHOD, filterSelectionState);
		const attendance = this.getFilterOptionValueBy(FilterKey.DELIVERY_METHOD, filterSelectionState);

		return metaRankingSortSelected
			&& attendanceSelected
			&& (attendance === AttendanceFilterOptionValue.BLENDED
				|| attendance === AttendanceFilterOptionValue.FACE_2_FACE
			);
	}

	protected selfHandle(filterSelectionState: FilterSelectionState): Promise<string> {
		const attendance = this.constructAttendanceDisplayName(filterSelectionState);

		const seoInfo = `Top Universities for ${attendance} learning | Studyportals University Meta Ranking`;

		return Promise.resolve(seoInfo);
	}

	private constructAttendanceDisplayName(filterSelectionState: FilterSelectionState): string {
		const attendance = this.getFilterOptionValueBy(FilterKey.DELIVERY_METHOD, filterSelectionState) ?? '';

		return attendance === AttendanceFilterOptionValue.FACE_2_FACE ? 'on campus' : attendance;
	}
}
